// extracted by mini-css-extract-plugin
module.exports = {"trainingLocationCollapse":"TrainingLocationList_trainingLocationCollapse__3NRDb","trainingLocationName":"TrainingLocationList_trainingLocationName__2-JLP"};